// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-year-mode_lightrope_JwLd9 {
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    position: absolute;
    z-index: 1;
    margin: -15px 0 0 0;
    padding: 0;
    pointer-events: none;
    width: 100vw;
    top: -5px;
    left: 0;
    display: flex;
    justify-content: flex-start;
}

.new-year-mode_lightrope_JwLd9 li {
    position: relative;
    animation-fill-mode: both;
    animation-iteration-count: infinite;
    list-style: none;
    margin: 0;
    padding: 0;
    display: block;
    width: 12px;
    height: 28px;
    border-radius: 50%;
    margin: 20px;
    display: inline-block;
    background: #00f7a5;
    box-shadow: 0px 4.66667px 24px 3px #00f7a5;
    animation-name: new-year-mode_flash-1_hwgRx;
    animation-duration: 2s;
}

.new-year-mode_lightrope_JwLd9 li:nth-child(2n+1) {
    background: cyan;
    box-shadow: 0px 4.66667px 24px 3px rgba(0, 255, 255, 0.5);
    animation-name: new-year-mode_flash-2_ZcTJ1;
    animation-duration: 0.4s;
}

.new-year-mode_lightrope_JwLd9 li:nth-child(4n+2) {
    background: #f70094;
    box-shadow: 0px 4.66667px 24px 3px #f70094;
    animation-name: new-year-mode_flash-3_rT8PF;
    animation-duration: 1.1s;
}

.new-year-mode_lightrope_JwLd9 li:nth-child(odd) {
    animation-duration: 1.8s;
}

.new-year-mode_lightrope_JwLd9 li:nth-child(3n+1) {
    animation-duration: 1.4s;
}

.new-year-mode_lightrope_JwLd9 li:before {
    content: "";
    position: absolute;
    background: #222;
    width: 10px;
    height: 9.33333px;
    border-radius: 3px;
    top: -4.66667px;
    left: 1px;
}

.new-year-mode_lightrope_JwLd9 li:after {
    content: "";
    top: -14px;
    left: 9px;
    position: absolute;
    width: 52px;
    height: 18.66667px;
    border-bottom: solid #222 2px;
    border-radius: 50%;
}

.new-year-mode_lightrope_JwLd9 li:last-child:after {
    content: none;
}

.new-year-mode_lightrope_JwLd9 li:first-child {
    margin-left: -40px;
}

@keyframes new-year-mode_flash-1_hwgRx {

    0%,
    100% {
        background: #00f7a5;
        box-shadow: 0px 4.66667px 24px 3px #00f7a5;
    }

    50% {
        background: rgba(0, 247, 165, 0.4);
        box-shadow: 0px 4.66667px 24px 3px rgba(0, 247, 165, 0.2);
    }
}

@keyframes new-year-mode_flash-2_ZcTJ1 {

    0%,
    100% {
        background: cyan;
        box-shadow: 0px 4.66667px 24px 3px cyan;
    }

    50% {
        background: rgba(0, 255, 255, 0.4);
        box-shadow: 0px 4.66667px 24px 3px rgba(0, 255, 255, 0.2);
    }
}

@keyframes new-year-mode_flash-3_rT8PF {

    0%,
    100% {
        background: #f70094;
        box-shadow: 0px 4.66667px 24px 3px #f70094;
    }

    50% {
        background: rgba(247, 0, 148, 0.4);
        box-shadow: 0px 4.66667px 24px 3px rgba(247, 0, 148, 0.2);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/dash-new-year-mode/new-year-mode.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,UAAU;IACV,oBAAoB;IACpB,YAAY;IACZ,SAAS;IACT,OAAO;IACP,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mCAAmC;IACnC,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,0CAA0C;IAC1C,2CAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,yDAAyD;IACzD,2CAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,0CAA0C;IAC1C,2CAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,WAAW;IACX,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI;;QAEI,mBAAmB;QACnB,0CAA0C;IAC9C;;IAEA;QACI,kCAAkC;QAClC,yDAAyD;IAC7D;AACJ;;AAEA;;IAEI;;QAEI,gBAAgB;QAChB,uCAAuC;IAC3C;;IAEA;QACI,kCAAkC;QAClC,yDAAyD;IAC7D;AACJ;;AAEA;;IAEI;;QAEI,mBAAmB;QACnB,0CAA0C;IAC9C;;IAEA;QACI,kCAAkC;QAClC,yDAAyD;IAC7D;AACJ","sourcesContent":[".lightrope {\n    text-align: center;\n    white-space: nowrap;\n    overflow: hidden;\n    position: absolute;\n    z-index: 1;\n    margin: -15px 0 0 0;\n    padding: 0;\n    pointer-events: none;\n    width: 100vw;\n    top: -5px;\n    left: 0;\n    display: flex;\n    justify-content: flex-start;\n}\n\n.lightrope li {\n    position: relative;\n    animation-fill-mode: both;\n    animation-iteration-count: infinite;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    display: block;\n    width: 12px;\n    height: 28px;\n    border-radius: 50%;\n    margin: 20px;\n    display: inline-block;\n    background: #00f7a5;\n    box-shadow: 0px 4.66667px 24px 3px #00f7a5;\n    animation-name: flash-1;\n    animation-duration: 2s;\n}\n\n.lightrope li:nth-child(2n+1) {\n    background: cyan;\n    box-shadow: 0px 4.66667px 24px 3px rgba(0, 255, 255, 0.5);\n    animation-name: flash-2;\n    animation-duration: 0.4s;\n}\n\n.lightrope li:nth-child(4n+2) {\n    background: #f70094;\n    box-shadow: 0px 4.66667px 24px 3px #f70094;\n    animation-name: flash-3;\n    animation-duration: 1.1s;\n}\n\n.lightrope li:nth-child(odd) {\n    animation-duration: 1.8s;\n}\n\n.lightrope li:nth-child(3n+1) {\n    animation-duration: 1.4s;\n}\n\n.lightrope li:before {\n    content: \"\";\n    position: absolute;\n    background: #222;\n    width: 10px;\n    height: 9.33333px;\n    border-radius: 3px;\n    top: -4.66667px;\n    left: 1px;\n}\n\n.lightrope li:after {\n    content: \"\";\n    top: -14px;\n    left: 9px;\n    position: absolute;\n    width: 52px;\n    height: 18.66667px;\n    border-bottom: solid #222 2px;\n    border-radius: 50%;\n}\n\n.lightrope li:last-child:after {\n    content: none;\n}\n\n.lightrope li:first-child {\n    margin-left: -40px;\n}\n\n@keyframes flash-1 {\n\n    0%,\n    100% {\n        background: #00f7a5;\n        box-shadow: 0px 4.66667px 24px 3px #00f7a5;\n    }\n\n    50% {\n        background: rgba(0, 247, 165, 0.4);\n        box-shadow: 0px 4.66667px 24px 3px rgba(0, 247, 165, 0.2);\n    }\n}\n\n@keyframes flash-2 {\n\n    0%,\n    100% {\n        background: cyan;\n        box-shadow: 0px 4.66667px 24px 3px cyan;\n    }\n\n    50% {\n        background: rgba(0, 255, 255, 0.4);\n        box-shadow: 0px 4.66667px 24px 3px rgba(0, 255, 255, 0.2);\n    }\n}\n\n@keyframes flash-3 {\n\n    0%,\n    100% {\n        background: #f70094;\n        box-shadow: 0px 4.66667px 24px 3px #f70094;\n    }\n\n    50% {\n        background: rgba(247, 0, 148, 0.4);\n        box-shadow: 0px 4.66667px 24px 3px rgba(247, 0, 148, 0.2);\n    }\n}"],"sourceRoot":""}]);
// Exports
export var lightrope = `new-year-mode_lightrope_JwLd9`;
var _1 = `new-year-mode_flash-1_hwgRx`;
export { _1 as "flash-1" };
export var flash1 = `new-year-mode_flash-1_hwgRx`;
var _2 = `new-year-mode_flash-2_ZcTJ1`;
export { _2 as "flash-2" };
export var flash2 = `new-year-mode_flash-2_ZcTJ1`;
var _3 = `new-year-mode_flash-3_rT8PF`;
export { _3 as "flash-3" };
export var flash3 = `new-year-mode_flash-3_rT8PF`;
export default ___CSS_LOADER_EXPORT___;
